import useTripStore from '../../context/TripStore';

/**
 * Individual stop card with remove/reorder functionality
 */
function StopCard({ place, index, onDragStart, onDragOver, onDrop }) {
  const removePlace = useTripStore((state) => state.removePlace);
  const updatePlace = useTripStore((state) => state.updatePlace);

  const priorityColors = {
    must_see: 'bg-red-100 text-red-700 border-red-200',
    want_to_see: 'bg-yellow-100 text-yellow-700 border-yellow-200',
    if_time_allows: 'bg-gray-100 text-gray-600 border-gray-200',
  };

  const priorityLabels = {
    must_see: 'Must see',
    want_to_see: 'Want to see',
    if_time_allows: 'If time',
  };

  const handlePriorityChange = (newPriority) => {
    updatePlace(place.id, { priority: newPriority });
  };

  return (
    <div
      draggable
      onDragStart={(e) => onDragStart?.(e, index)}
      onDragOver={(e) => onDragOver?.(e, index)}
      onDrop={(e) => onDrop?.(e, index)}
      className="flex items-center gap-1.5 p-2 bg-white rounded-lg border border-gray-200 shadow-sm cursor-grab active:cursor-grabbing"
    >
      {/* Stop number */}
      <div className="flex-shrink-0 w-5 h-5 bg-blue-600 text-white rounded-full flex items-center justify-center text-[10px] font-medium">
        {index + 1}
      </div>

      {/* Place info */}
      <div className="flex-1 min-w-0 overflow-hidden">
        <p className="font-medium text-gray-900 truncate text-xs">{place.name}</p>
      </div>

      {/* Priority badge */}
      <select
        value={place.priority || 'want_to_see'}
        onChange={(e) => handlePriorityChange(e.target.value)}
        className={`flex-shrink-0 text-[10px] px-1.5 py-0.5 rounded-full border ${
          priorityColors[place.priority || 'want_to_see']
        } cursor-pointer focus:outline-none`}
      >
        <option value="must_see">{priorityLabels.must_see}</option>
        <option value="want_to_see">{priorityLabels.want_to_see}</option>
        <option value="if_time_allows">{priorityLabels.if_time_allows}</option>
      </select>

      {/* Remove button */}
      <button
        type="button"
        onClick={() => removePlace(place.id)}
        className="flex-shrink-0 p-0.5 text-gray-400 hover:text-red-500 rounded hover:bg-red-50 transition-colors"
      >
        <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
}

export default StopCard;
